import { defineMessage } from '../internal-messaging';
// Ping to check if window/scope has a relay
const probe = defineMessage('cd-relay/probe');
const probeReply = defineMessage('cd-relay/probe-reply', payload => payload);
const handshake = defineMessage('cd-relay/handshake', payload => payload);
const handshakeResponse = defineMessage('cd-relay/handshake-response', payload => payload);
const topicSubscribe = defineMessage('cd-relay/topic-subscribe', payload => payload);
const topicUnsubscribe = defineMessage('cd-relay/topic-unsubscribe', payload => payload);
const getTopicSubscriptions = defineMessage('cd-relay/getTopicSubscriptions', payload => payload);
const getTopicSubscriptionsResponse = defineMessage('cd-relay/getTopicSubscriptionsResponse', payload => payload);
const close = defineMessage('cd-relay/close', payload => payload);
const sendMessage = defineMessage('cd-relay/sendMessage', message => message);
const relayMessage = defineMessage('cd-relay/relayMessage', message => message);

// Response to an operation that doesn't require specific payload response but we want to know was performed successfully
const opCompletedConfirmation = defineMessage('cd-relay/operation-completed-confirmation', requestId => requestId);
const opFailedConfirmation = defineMessage('cd-relay/operation-failed-confirmation', payload => payload);
export const relayOperations = {
  probe,
  probeReply,
  handshake,
  handshakeResponse,
  topicSubscribe,
  topicUnsubscribe,
  getTopicSubscriptions,
  getTopicSubscriptionsResponse,
  close,
  sendMessage,
  relayMessage,
  opCompletedConfirmation,
  opFailedConfirmation
};